/**
 * escape — helper anti-XSS UNICO per tutti i template a stringa (viste, sezioni,
 * SVG). Prima esistevano 3 copie divergenti (escapeHtml/escapeXml/esc) sparse
 * nelle viste; questa è la fonte unica (standardizzazione D1).
 */

/** HTML (testo e attributi): escapa & < > " ' (apostrofo come &#39;, sicuro ovunque). */
export function escapeHtml(s: string): string {
  return s.replace(/[&<>"']/g, (c) => (
    c === '&' ? '&amp;' :
    c === '<' ? '&lt;' :
    c === '>' ? '&gt;' :
    c === '"' ? '&quot;' : '&#39;'
  ));
}

/** Alias semantico per i valori di attributo (stesso comportamento di escapeHtml). */
export const escapeAttr = escapeHtml;

/** SVG/XML: come escapeHtml ma apostrofo come &apos; (entità valida in XML). */
export function escapeXml(s: string): string {
  return s.replace(/[&<>"']/g, (c) => (
    c === '&' ? '&amp;' :
    c === '<' ? '&lt;' :
    c === '>' ? '&gt;' :
    c === '"' ? '&quot;' : '&apos;'
  ));
}
